import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const UserNav = ({ handleLogout }) => {
  const { user } = useAuth();
  let navigate = useHistory();
  function getEmailInitials(email) {
    if (!email) return "";
    const name = email.split("@")[0];

    if (name.includes(".") || name.includes("_") || name.includes("-")) {
      const nameParts = name.split(/[.\-_]/);

      const initials = nameParts
        .map((part) => part.charAt(0).toUpperCase())
        .join("");

      return initials;
    } else {
      return name.charAt(0).toUpperCase();
    }
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-8 w-8 rounded-full">
          <Avatar className="h-9 w-9 bg-primary">
            <AvatarImage src="/avatars/03.png" alt="user-avatar" />
            <AvatarFallback className="text-white bg-primary">
              {getEmailInitials(user?.signInDetails?.loginId)}
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">TriVista</p>
            <p className="text-xs leading-none text-muted-foreground">
              {user?.signInDetails?.loginId}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem disabled>Profile</DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate.push("/settings")}>
            Change Password
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout}>Log out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
